import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { COLORS } from "constants/colors";
import Footer from "works/irene/components/Footer";

function EpisodeBox({ index }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        gap: 2, // 画像の間に適度な余白を作る
      }}
    >
      {/* アイキャッチ画像 (角丸) */}
      <Box
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
          width: "26%", // 明示的に幅を指定
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={`/irene/episodes/eye_catches/${index}.png`}
          alt="episodes"
          style={{ width: "100%", borderRadius: "8px", display: "block" }}
        />
      </Box>

      {/* 説明画像 */}
      <Box
        sx={{
          width: "48%", // 幅を明示的に指定
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={`/irene/episodes/descriptions/${index}.svg`}
          alt="episodes"
          style={{ width: "100%", display: "block" }}
        />
      </Box>
    </Box>
  );
}

function IreneStory() {
  const soulId = "irene_sekacos_line_ja";
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        // backgroundColor: COLORS.BACKGROUND_WHITE, // 明るいグレー
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 5,
          width: "100%",
          // backgroundSize: "contain",
        }}
      >
        {/* <img src="/catch_phrase.png" alt="logo" width="400px" /> */}
        <Box sx={{ position: "relative", width: "100%" }}>
          {/* 背景画像 */}
          <img
            src="/irene/title_image.png"
            alt="title_image"
            width="100%"
            style={{ display: "block" }} // 隙間をなくす
          />

          {/* タイトルロゴ */}
          <Box
            sx={{
              position: "absolute",
              top: "26%", // 上から26%の位置に配置
              left: "50%", // 左から50%の位置に配置
              transform: "translate(-50%, -50%)", // 中央に正確に配置
              width: "50%", // ロゴの幅を調整
            }}
          >
            <img
              src="/irene/title_logo.svg"
              alt="title_logo"
              width="100%" // 親のBoxに合わせる
              style={{ display: "block" }} // 隙間をなくす
            />
          </Box>
        </Box>

        <img src="/irene/story.svg" alt="story" width="100%" />
        {/* <img src="/irene/episodes.svg" alt="episodes" width="100%" /> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 3,
            gap: 3,
            width: "100%",
          }}
        >
          <img src="/irene/headers/episodes.svg" alt="episodes" width="30%" />
          <EpisodeBox index={1} />
          <EpisodeBox index={2} />
          <img src="/irene/dash.svg" alt="dash" width="5px" />
        </Box>

        <Button
          variant="contained"
          sx={{
            width: "60%",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "8px",
            mb: 5,
            height: "54px",
            background: "#173567",
            "&:hover": {
              background: "#173567", // ボタンのグラデーションを維持
              opacity: 0.9, // ホバー時の軽いエフェクト
            },
          }}
          onClick={() => navigate(`/episodes?soul_id=${soulId}`)}
        >
          <img
            src="/irene/check_episodes.svg"
            alt="全エピソードを見る"
            height="40%"
          />
        </Button>
      </Box>

      <Footer soulId={soulId} />
    </Box>
  );
}

export default IreneStory;
